import * as types from './types'

export default {
  [types.SET_CRITERIA_CHANGED](state, value) {
    state.criteriaChanged = value
  },
  [types.SET_STEP](state, data) {
    state.step = data
  },
  [types.SET_VISITED_STEP](state, currentStep) {
    state.visitedStep = currentStep > state.visitedStep
      ? currentStep
      : state.visitedStep
  },
  [types.RESET_VISITED_STEP](state, data) {
    state.visitedStep = data
  },
  [types.RESET_RECOMMENDATION](state) {
    state.recommendation = JSON.parse(JSON.stringify(state.newRecommendation))
  },
  [types.PREP_RECOMMENDATION](state, firm) {
    state.recommendation.firm = firm
    state.recommendation.calibrateRecommendation = null
  },
  [types.UPDATE_RECOMMENDATION](state, data) {
    if (state.recommendation !== null && data !== null) {
      switch (data.name) {
        case 'firm':
          state.recommendation.firm = parseInt(data.value)
          break
        case 'vehicleMake':
          state.recommendation.vehicleMake = parseInt(data.value)
          break
        case 'calibrateType':
          state.recommendation.calibrateType = parseInt(data.value)
          break
        case 'recommendation':
          state.recommendation.recommendation = data.value
          break
        case 'recommendationText':
          state.recommendation.recommendationText = data.value
          break
      }
    }
  },
  [types.SET_RECOMMENDATIONS](state, data) {
    state.recommendations = data
  },
  [types.SET_RECOMMENDATION](state, data) {
    state.recommendation = data
  },
  [types.RESET_TRANSLATIONS](state, data) {
    state.translations = []
  },
  [types.SET_TRANSLATIONS](state, data) {
    state.translations = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.translations = data
      }
    }
  },
  [types.UPDATE_BMS_REPAIRS](state, repairData) {
    let found = state.bmsRepairs.find(x => x.repairData === repairData)
    if (found !== undefined && found !== null) {
      found.isProcessed = true
    }
  },
  [types.SET_BMS_REPAIRS](state, data) {
    state.bmsRepairs = []
    if (data !== undefined && data !== null) {
      data.forEach(element => {
        element.isProcessed = false
        state.bmsRepairs.push(element)
      })
    }
  },
  [types.SET_BMS_XML](state, data) {
    state.bmsXml = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/mutations.js